var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"uppercase"},[_vm._v("POP-Builder R"),_c('span',{staticClass:"lowercase"},[_vm._v("X")]),(_vm.tm)?_c('span',[_vm._v("™")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }